import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./base-query";
import "./user.api";

export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "user",
    "questionnaires",
    "Conversations",
    "ConversationHistory",
    "QuestionnaireMap",
    "language",
    "Features",
    "TreatmentRooms",
    "TreatmentGroups",
    "admin",
    "Company",
    "CompanySizes",
    "Sectors",
    "paymentPeriodTypes",
    "Plans",
    "Stages",
    "ExerciseAssignments",
    "RiskAlerts",
    "ClinicalSummary",
    "PendingAppointmentsPrograms",
    "permissions",
    "SmartReportHistory",
    "CompanyServices",
    "CompanyServicesPrices",
    "CompanyFundingSources",
    "PaymentToken",
    "Questionnaires",
    "PaymentClearingConfig",
    "PaymentLinkSettings",
    "PaymentLinkSessions",
    "UserDebt",
    "UserPayments",
    "TutorialVideos",
    "TutorialCategories",
    "AppointmentSeries",
    "AppointmentProgramSessions",
    "UserComments",
    "UserAdminComments",
    "Jobs",
    "UnreportedAppointments",
    "AiTier",
    "CompanyDefaultSettings",
    "PatientDefaultServicePrice",
    "ClientFiles",
    "FeatureCreditPackages",
    "FeatureCreditPurchases",
    "CompanySubscription",
    "TreatmentProtocols",
    "HotlineQuestionnairePolicies",
    "HotlineQuestionnaireRequirements",
    "UserTreatmentProtocol",
    "FileSubjects",
    "CompanyDevices",
    "SeatSubscriptions",
    "PeriodicReportSavedSearches",
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
